import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

const STORAGE_KEY = "filter_tenant"

/** Gesperrter Browser-Speicher wirft beim Lesen — dann eben „alle" (#96).
 *  Ohne das stuerzte die Navigation und mit ihr das ganze Portal ab. */
function gemerkterTenant(): string {
  try {
    return typeof localStorage !== "undefined" ? (localStorage.getItem(STORAGE_KEY) || "") : ""
  } catch {
    return ""
  }
}

/**
 * Tenant-Filter-Hook — liest/schreibt den `tenant`-Query-Param in der URL
 * UND persistiert in localStorage, damit die Auswahl beim Seitenwechsel erhalten bleibt.
 * Leerer String = "Alle Tenants".
 */
export function useTenantFilter() {
  const [params, setParams] = useSearchParams()
  const urlTenant = params.get("tenant")
  const tenant = urlTenant !== null ? urlTenant : gemerkterTenant()

  // Bei Mount: wenn URL keinen Tenant hat aber localStorage einen → in URL synchen
  // (damit useQuery-Keys & Co. den richtigen Wert sehen).
  useEffect(() => {
    if (urlTenant === null && tenant) {
      const next = new URLSearchParams(params)
      next.set("tenant", tenant)
      setParams(next, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setTenant = (v: string) => {
    try {
      if (v) localStorage.setItem(STORAGE_KEY, v)
      else localStorage.removeItem(STORAGE_KEY)
    } catch { /* quota / private mode */ }
    const next = new URLSearchParams(params)
    if (v) next.set("tenant", v)
    else next.delete("tenant")
    setParams(next, { replace: true })
  }

  return [tenant, setTenant] as const
}
